'use strict'
import { useCallback, useEffect, useRef, useState } from 'react'

import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { AgGridReact } from 'ag-grid-react'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { Toast } from 'primereact/toast'
import { Toolbar } from 'primereact/toolbar'

import ExportButton from '../../../components/CustomButtons/exportGreenButton'
import { TableLineDisable } from '../../../components/TableLineDisable/TableLineDisable'
import { RULES, validRule } from '../../../constants/Entitlements'
import { api, request } from '../../../util/handlerRequestUtil'
import { getMessage } from '../../../util/IntlMessages'

import './style.css'

function ListActionTypesJSON() {
  const [data, setData] = useState([])
  const [gridApi, setGridApi] = useState(null)
  const gridRef = useRef()
  const toast = useRef(null)

  useEffect(() => {
    loadData()
  }, [])

  async function loadData() {
    const items = await request(api.listCustomFieldsJSON())
    setData(items)
  }

  const updateData = async (id, reportGroup, isJsonText, fieldName) => {
    try {
      await request(api.updateCustomFieldJSON(id, reportGroup, isJsonText))
      toast.current.show({
        severity: 'info',
        summary: `${fieldName} atualizado com sucesso.`,
        life: 3000
      })
      loadData()
    } catch (error) {
      toast.current.show({
        severity: 'danger',
        summary: `Não foi possivel atualizar ${fieldName}.`,
        life: 3000
      })
    }
  }

  function getColumns() {
    const columns = [
      {
        headerName: getMessage('actionTypeId'),
        field: 'name',
        filter: 'agTextColumnFilter',
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: getMessage('customFieldFormName'),
        field: 'fieldName',
        filter: 'agTextColumnFilter',
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: 'Incluir no JSON',
        field: 'isJsonText',
        filter: 'agTextColumnFilter',
        editable: true,
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: ['Sim', 'Não']
        },
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: 'Grupo do JSON Report',
        field: 'reportGroup',
        filter: 'agNumberColumnFilter',
        editable: true,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      }
    ]

    const hasAccess = validRule(RULES.ACTION_TYPE_JSON) // Remove o lapis da lista
    if (hasAccess === true) {
      return columns
    }

    if (columns !== null) {
      columns.pop()
      return columns
    }
  }

  const defaultColDef = {
    sortable: true,
    resizable: true,
    minWidth: 150,
    floatingFilter: true
  }

  const onGridReady = (params) => {
    setGridApi(params.api)
    params.api.sizeColumnsToFit()
  }

  const onFilterTextBoxChanged = useCallback(() => {
    const value = document.getElementById('filter-text-box').value
    gridRef.current.api.setGridOption('quickFilterText', value)
  }, [])

  function renderHeader() {
    const leftContents = (
      <h2>
        <b>JSON Report</b>
      </h2>
    )

    const rightContents = (
      <div className="container-header-lists">
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText
            type="text"
            style={{ width: '100%', height: '40px', fontSize: '14px' }}
            id="filter-text-box"
            placeholder="Pesquisar"
            onInput={onFilterTextBoxChanged}
          />
        </IconField>

        <div>
          <ExportButton
            iconType="csv"
            label={getMessage('label.exportCvs')}
            onClick={() => gridApi.exportDataAsCsv()}
          />
        </div>
      </div>
    )

    return <Toolbar start={leftContents} end={rightContents} />
  }

  const onCellEditingStopped = useCallback(({ data }) => {
    updateData(data.id, data.reportGroup == '' ? null : data.reportGroup, data.isJsonText, data.fieldName)
  }, [])

  return (
    <>
      {renderHeader()}
      <div style={{ width: '100%', height: '70vh' }} className="ag-theme-alpine">
        <Toast ref={toast} />
        <AgGridReact
          columnDefs={getColumns()}
          defaultColDef={defaultColDef}
          rowData={data}
          onGridReady={onGridReady}
          rowSelection={'single'}
          rowGroupPanelShow={'always'}
          pivotPanelShow={'always'}
          ref={gridRef}
          cacheQuickFilter={true}
          serverSideInfiniteScrolling={true}
          cacheBlockSize={50}
          maxBlocksInCache={2}
          onCellEditingStopped={onCellEditingStopped}
        />
      </div>
    </>
  )
}

export default ListActionTypesJSON
